var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('v-container',_vm._b({staticClass:"pa-0",attrs:{"fluid":""}},'v-container',( _obj = {}, _obj["grid-list-md"] = true, _obj ),false),[_c('v-layout',{staticClass:"ma-0 pa-0",staticStyle:{"overflow":"hidden","overflow-x":"auto"}},_vm._l((_vm.items),function(subItem){return _c('v-flex',{key:subItem.Header,style:({
        'min-width': _vm.getMultipleCardWidth(_vm.items.length),
        'max-width': _vm.getMultipleCardWidth(_vm.items.length),
      })},[_c('base-contentpage-landingpage-card',{attrs:{"maxWidth":_vm.getMultipleCardWidth(_vm.items.length),"small":"","item":subItem}})],1)}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }